import { VariaveisAmbiente } from 'config';
import { useCallback } from 'react';
import { useApiBase } from '../../base/api-base';
import { VotoModel } from 'model/api/gestao/votacao-desenvolvimento/voto-model';

export function usePostVotacoesByIdVoto() {
    const { invocarApi, ...outrasPropriedades } = useApiBase();

    const postVotacoesByIdVoto = useCallback(
        (model: VotoModel, tarefaId: string) =>
            invocarApi({
                url: `/api/v1/votacao/${tarefaId}/voto`,
                data: model,
                method: 'POST',
                enviarTokenUsuario: true,
                baseURL: VariaveisAmbiente.apiClickupLicUrl,
            }),
        [invocarApi],
    );
    return {
        ...outrasPropriedades,
        postVotacoesByIdVoto,
    };
}
